angular.module('impactx.panel').controller('CatalogPanelCtrl', [
    'TranslationService',
    '$redirect',
    '$config',
    'ThemeWorldService',
    'panelService',
    '$context',
    'AppConfiguration',
    'OCICatalogService',
    'ProductViewService',
    'SearchFilterStorage',
    'ExtendedCatalogTooltipService',
    '$routeParams',
    CatalogPanelCtrl]);

function CatalogPanelCtrl(TranslationService, $redirect, $config, ThemeWorldService, panelService, $context, AppConfiguration,
                          OCICatalogService, ProductViewService, SearchFilterStorage, ExtendedCatalogTooltipService, $routeParams) {
    var self = this;
    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        toExternalCat: TranslationService.get("toExternalCat"),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView'),
        externalCatalog: TranslationService.get('externalCatalog')
    };

    self.getCatalogPanelColor = panelService.getCatalogPanelColor;

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');


    self.showExtendedTooltip = function(event, catalog) {
        if (self.catalog && self.catalog.hasDescription) {
            ExtendedCatalogTooltipService.open(event, catalog, 500);
        }
    };

    self.closeExtendedTooltip = function () {
        if (self.catalog) {
            ExtendedCatalogTooltipService.close();
        }
    };

    self.redirectToCatalog = function() {
        ExtendedCatalogTooltipService.stopTimer();
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.vcatalogId = {value: self.catalog.id};
            filter.dialogFilter = "vcat";
            filter.prgId = {value: 0};
            SearchFilterStorage.setVCatFilter(self.catalog.id, filter);
            $redirect.redirectTo(null, "vcatalog/" + self.catalog.id + "/0/true");
        }
        else {
            if (self.currentFilter) {
                var filter = JSON.parse(JSON.stringify(self.currentFilter));
                filter.vcatalogId = {value: self.catalog.id};
                filter.dialogFilter = "vcat";
                filter.prgId = {value: 0};
                filter.productPageNumber = 0;
                SearchFilterStorage.setVCatFilter(self.catalog.id, filter);
            }
            $redirect.redirectTo(null, (self.catalogRedirect ? self.catalogRedirect : "/vcatalog/") + self.catalog.id + (self.currentFilter ? "/0/true" : ""));
        }
    };

    self.redirectToSupplier = function(event) {
        ExtendedCatalogTooltipService.stopTimer();
        event.stopPropagation();
        $redirect.redirectTo(null, "/supplier/" + self.catalog.supplierId);
    };

    self.addToThemeWorld = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addVCatsToThemeWorld([self.catalog]);
    };

    self.removeFromThemeWorld = function($event) {
        var vcatIds = [];
        self.catalog.tw.add = true;
        self.catalog.tw.remove = false;
        vcatIds.push(self.catalog.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeVCatsFromThemeWorld($context.hasActiveThemeWorld.id, vcatIds);
    };

    self.addToProductView = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addVCatsToProductView([self.catalog]);
    };

    self.removeFromProductView = function($event) {
        var vcatIds = [];
        self.catalog.pv.add = true;
        self.catalog.pv.remove = false;
        vcatIds.push(self.catalog.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeVCatsFromProductView($context.hasActiveProductView.id, vcatIds);
    };

    self.toExternalCatalog ={
        label: self.trns.toExternalCat
    };
    
    self.toExternalCatalogP ={
        label: self.trns.toExternalCat
    };

    self.toExternalCatalog.func = function(event) {
        ExtendedCatalogTooltipService.stopTimer();
        if (self.catalog.catalog && self.catalog.catalog.isExternal) {
            OCICatalogService.toExternalCat(self.catalog.catalog);
            event.stopPropagation();
        }
    };

    self.toExternalCatalogP.func = function(event) {
        ExtendedCatalogTooltipService.stopTimer();
        if (self.catalog.catalog && self.catalog.catalog.isExternal) {
            OCICatalogService.toExternalCatP(self.catalog.catalog);
            event.stopPropagation();
        }
    };
}
